// src/pages/TermsAndConditions.jsx
import { Box, Container, Title, Text, Stack, List } from "@mantine/core";

export default function TermsAndConditions() {
  return (
    <Box style={{ backgroundColor: "#f0ede8", minHeight: "100vh" }}>
      <Container size="md" py={60}>
        <Stack gap={32}>

          {/* Header */}
          <Stack gap={8}>
            <Title order={1} fw={900} c="#1a1a1a">
              Terms & Conditions
            </Title>

            <Text c="#888" size="sm">
              Last updated:{" "}
              {new Date().toLocaleDateString("en-IN", {
                day: "numeric",
                month: "long",
                year: "numeric",
              })}
            </Text>
          </Stack>

          {/* Intro */}
          <Text c="#555" style={{ lineHeight: 1.8 }}>
            These Terms & Conditions govern the use of RentalFlow by rental
            shop owners and partners ("Partners"). By registering for or using
            RentalFlow, you agree to comply with these Terms & Conditions.
          </Text>

          {/* Section 1 */}
          <Stack gap={10}>
            <Title order={3} fw={800} c="#1a1a1a">
              1. Platform Role
            </Title>

            <Text c="#555" style={{ lineHeight: 1.8 }}>
              RentalFlow operates solely as a technology-enabled marketplace
              platform connecting Partners with Customers seeking vehicle
              rentals. RentalFlow does not own, operate, insure, or manage
              listed vehicles.
            </Text>
          </Stack>

          {/* Section 2 */}
          <Stack gap={10}>
            <Title order={3} fw={800} c="#1a1a1a">
              2. Partner Eligibility
            </Title>

            <Text c="#555" style={{ lineHeight: 1.8 }}>
              Partners must:
            </Text>

            <List spacing="sm" c="#555">
              <List.Item>Be at least 18 years old</List.Item>
              <List.Item>
                Be the legal owner or authorised operator of the rental business
              </List.Item>
              <List.Item>Provide valid business information</List.Item>
              <List.Item>Submit accurate KYC documents</List.Item>
            </List>
          </Stack>

          {/* Section 3 */}
          <Stack gap={10}>
            <Title order={3} fw={800} c="#1a1a1a">
              3. Vehicle Responsibilities
            </Title>

            <Text c="#555" style={{ lineHeight: 1.8 }}>
              Partners are responsible for ensuring that vehicles listed or
              rented through their business:
            </Text>

            <List spacing="sm" c="#555">
              <List.Item>Have valid registration</List.Item>
              <List.Item>Are roadworthy</List.Item>
              <List.Item>Have valid insurance</List.Item>
              <List.Item>Match the listed description</List.Item>
            </List>
          </Stack>

          {/* Section 4 */}
          <Stack gap={10}>
            <Title order={3} fw={800} c="#1a1a1a">
              4. Customer Verification
            </Title>

            <Text c="#555" style={{ lineHeight: 1.8 }}>
              Before handing over a vehicle, Partners must verify:
            </Text>

            <List spacing="sm" c="#555">
              <List.Item>Customer identity</List.Item>
              <List.Item>Valid driving licence</List.Item>
              <List.Item>Applicable minimum age requirements</List.Item>
            </List>
          </Stack>

          {/* Section 5 */}
          <Stack gap={10}>
            <Title order={3} fw={800} c="#1a1a1a">
              5. Payments & Subscription
            </Title>

            <Text c="#555" style={{ lineHeight: 1.8 }}>
              Rental payments are made directly between Customers and Partners.
              RentalFlow does not process or collect vehicle rental payments
              unless explicitly stated otherwise. RentalFlow charges
              subscription fees for access to the platform and its services.
            </Text>
          </Stack>

          {/* Section 6 */}
          <Stack gap={10}>
            <Title order={3} fw={800} c="#1a1a1a">
              6. Liability
            </Title>

            <Text c="#555" style={{ lineHeight: 1.8 }}>
              RentalFlow is not responsible for:
            </Text>

            <List spacing="sm" c="#555">
              <List.Item>Vehicle damage</List.Item>
              <List.Item>Theft or loss of a vehicle</List.Item>
              <List.Item>Traffic violations or penalties</List.Item>
              <List.Item>Customer non-payment</List.Item>
              <List.Item>Road accidents or injuries</List.Item>
            </List>
          </Stack>

          {/* Section 7 */}
          <Stack gap={10}>
            <Title order={3} fw={800} c="#1a1a1a">
              7. Prohibited Conduct
            </Title>

            <Text c="#555" style={{ lineHeight: 1.8 }}>
              Partners must not:
            </Text>

            <List spacing="sm" c="#555">
              <List.Item>Create fake or misleading listings</List.Item>
              <List.Item>Submit forged or false documents</List.Item>
              <List.Item>Misrepresent vehicles or their condition</List.Item>
              <List.Item>
                Share RentalFlow QR codes with unauthorised persons or businesses
              </List.Item>
            </List>
          </Stack>

          {/* Section 8 */}
          <Stack gap={10}>
            <Title order={3} fw={800} c="#1a1a1a">
              8. Privacy & Data
            </Title>

            <Text c="#555" style={{ lineHeight: 1.8 }}>
              Customer data collected through RentalFlow must only be used for
              legitimate rental-related purposes. Partners are responsible for
              handling customer information securely and in accordance with
              applicable Indian data protection laws and RentalFlow's Privacy
              Policy.
            </Text>
          </Stack>

          {/* Section 9 */}
          <Stack gap={10}>
            <Title order={3} fw={800} c="#1a1a1a">
              9. Changes to Terms
            </Title>

            <Text c="#555" style={{ lineHeight: 1.8 }}>
              RentalFlow may update these Terms & Conditions from time to time.
              Continued use of the platform after changes are published
              constitutes acceptance of the revised Terms & Conditions.
            </Text>
          </Stack>

          {/* Section 10 */}
          <Stack gap={10}>
            <Title order={3} fw={800} c="#1a1a1a">
              10. Contact Us
            </Title>

            <Text c="#555" style={{ lineHeight: 1.8 }}>
              If you have any questions regarding these Terms & Conditions,
              please contact us:
            </Text>

            <Text c="#f24c1a" fw={700}>
              Instagram: @rentalflow.in
            </Text>

            <Text c="#f24c1a" fw={700}>
              Phone: +91 8172818877
            </Text>

            <Text c="#f24c1a" fw={700}>
              Website: rentalflow.in
            </Text>

            <Text
            component="a"
            href="mailto:help@rentalflow.in"
            c="#f24c1a"
            fw={700}
            style={{ textDecoration: "none" }}
            >
            Email: help@rentalflow.in
            </Text>
          </Stack>

        </Stack>
      </Container>

      {/* Footer */}
      <Box py={24} style={{ borderTop: "1px solid #e0ddd8" }}>
        <Container>
          <Text ta="center" size="sm" c="#777">
            © {new Date().getFullYear()} RentalFlow · Smart Rentals Made Simple
          </Text>
        </Container>
      </Box>
    </Box>
  );
}